import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { api, type Overview as OverviewData } from "../api";

export function Overview() {
  const [d, setD] = useState<OverviewData>();
  const [err, setErr] = useState("");
  useEffect(() => { api<OverviewData>("/admin/overview").then(setD).catch((e: Error) => setErr(e.message)); }, []);
  if (err) return <div className="msg err">{err}</div>;
  if (!d) return <p className="chrome">Loading…</p>;

  const s = d.stats;
  const views = s.byType.card_view ?? 0, opens = s.byType.card_open ?? 0, completes = s.byType.chain_complete ?? 0;
  const openRate = views ? Math.round((opens / views) * 100) : 0;
  const max = Math.max(1, ...s.byDay.map((x) => x.counts.card_view ?? 0));

  return (
    <>
      <h2>Overview</h2>
      <p className="sub">API {d.stage} · build {d.version}</p>

      <div className="stats">
        <Stat label="Chains" v={d.spreads.total} sub={`${d.spreads.approved} approved${d.spreads.withErrors ? ` · ${d.spreads.withErrors} with errors` : ""}`} />
        <Stat label="Published on CDN" v={d.published} />
        <Stat label="Sessions · 7d" v={s.sessions} sub={`${s.visitors} visitors`} />
        <Stat label="Cards per session" v={s.sessions ? (views / s.sessions).toFixed(1) : "–"} />
        <Stat label="Swiped past beat 1" v={`${openRate}%`} sub={`${opens} of ${views}`} />
        <Stat label="Finished" v={completes} sub="reached the last beat" />
      </div>

      <div className="head">Card views, last 7 days</div>
      <div className="bars">
        {s.byDay.map((x) => (
          <div key={x.day} className="bar" style={{ height: `${((x.counts.card_view ?? 0) / max) * 100}%` }} title={`${x.day}: ${x.counts.card_view ?? 0} views, ${x.counts.card_open ?? 0} opens`}>
            <span>{x.counts.card_view ?? 0}</span>
          </div>
        ))}
      </div>
      <div className="days">{s.byDay.map((x) => <div key={x.day}>{x.day.slice(5)}</div>)}</div>

      <div className="head" style={{ marginTop: 36 }}>Chains by opens</div>
      <table className="tbl" style={{ marginTop: 8 }}>
        <thead><tr><th>Chain</th><th className="num">Views</th><th className="num">Opens</th><th className="num">Open rate</th><th className="num">Finished</th></tr></thead>
        <tbody>
          {s.bySpread.length === 0 && <tr><td colSpan={5} className="chrome">No events yet.</td></tr>}
          {s.bySpread.map((r) => (
            <tr key={r.spreadId}><td><Link to={`/admin/spreads/${r.spreadId}`}>{r.spreadId}</Link></td><td className="num">{r.views}</td><td className="num">{r.opens}</td><td className="num">{Math.round(r.openRate * 100)}%</td><td className="num">{r.completes}</td></tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

function Stat({ label, v, sub }: { label: string; v: string | number; sub?: string }) {
  return <div className="stat"><div className="head">{label}</div><div className="v">{v}</div>{sub && <div className="chrome">{sub}</div>}</div>;
}
